import { render, staticRenderFns } from "./selectExtra.vue?vue&type=template&id=6c51ed70&scoped=true&"
import script from "./selectExtra.vue?vue&type=script&lang=js&"
export * from "./selectExtra.vue?vue&type=script&lang=js&"
import style0 from "./selectExtra.vue?vue&type=style&index=0&id=6c51ed70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c51ed70",
  null
  
)

export default component.exports